export default [
  {
    backgroundColor: '#d13400',
    heroImg: 'https://backlight.dev/assets/lib-white/furious.svg',
    desc: `<ul class="list-disc list-inside">
    <li>Based on <code>fast-components</code></li>
    <li>FAST Design Tokens</li>
    <li>40+ accessible components</li>
    <li>Adaptive color system</li>
    <li>Dark mode support</li>
    </ul>`,
    url: '/signin?redirect=/edit/xS11aQmjMLIvr5PU5Mru',
    bgImg: 'https://backlight.dev/assets/lib-white/fast.svg',
    highlighted: true,
    frameworks: new Map([
      ['FAST', 'https://backlight.dev/assets/lib-white/fast.svg'],
      [
        'Web Components',
        'https://backlight.dev/assets/lib-white/web-components.svg',
      ],
    ]),
  },
  {
    backgroundColor: 'rgb(245 158 11)',
    heroImg: 'https://backlight.dev/assets/lib-white/simba.svg',
    desc: `<ul class="list-disc list-inside">
    <li>Based on Lion's accessible components</li>
    <li>Design Tokens in JSON</li>
    <li>20+ Web Components</li>
    <li>Style inspired by TailwindCSS</li>
    <li>Dark mode out-of-the-box</li>
    </ul>`,
    url: '/signin?redirect=/edit/5vtJtbY04aoD1dGKcsu1',
    bgImg: 'https://backlight.dev/assets/lib-white/lit.svg',
    highlighted: true,
    frameworks: new Map([
      ['Lion', 'https://backlight.dev/assets/lib-white/lion.svg'],
      ['Lit', 'https://backlight.dev/assets/lib-white/lit.svg'],
      [
        'Web Components',
        'https://backlight.dev/assets/lib-white/web-components.svg',
      ],
    ]),
  },
  {
    backgroundColor: '#30c6b9',
    heroImg: 'https://backlight.dev/assets/lib-white/yogi.svg',
    desc: `<ul class="list-disc list-inside">
    <li>Based on Chakra's accessible components</li>
    <li>Design Tokens in System-UI</li>
    <li>40+ Components</li>
    <li>Stories and documentation sourced from Chakra directly</li>
    </ul>`,
    url: '/signin?redirect=/edit/sNbJipmRTmslL3f8RZaO',
    bgImg: 'https://backlight.dev/assets/lib-white/react.svg',
    highlighted: true,
    frameworks: new Map([
      ['Chakra UI', 'https://backlight.dev/assets/lib-white/chakra-ui.svg'],
      ['React', 'https://backlight.dev/assets/lib-white/react.svg'],
      ['emotion', 'https://backlight.dev/assets/lib-white/emotion.svg'],
      ['System-UI', 'https://backlight.dev/assets/lib-white/system-ui.svg'],
    ]),
  },
];
